module.exports = __webpack_public_path__ + "img/DesktopAccessDisabledOutlined.45742a52.svg";